import { FC, useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../../..";
import { getEnv } from "../../../../../AppConfigs";
import { Routes } from "../../../../../AppRoutes";
import { Icon } from "../../../../../components/icon";
import { ProcessContextProvider, ProcessContextType } from "../../../process-context";
import ItDeleteAccountInformation from "./information";
import ItDeleteAccountProgress from "./progress";
import { useUpdateDAR } from "../hooks/use-update-DAR";
import { useUser } from "../../../../../hook";
import { useDetailsDAR } from "../hooks/use-details-DAR";
import { Spin } from "antd";

export const siteUrl = getEnv("REACT_APP_APPROVER_DELETE_ACCOUNT_REQUEST_URL");

export const deleteUserAccountDetailPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const [comment, setComment] = useState("");
  const { updateDeleteAccountRequest } = useUpdateDAR();
  const { email } = useUser();
  const { data: itDeleteAccountRequest, isLoading, isPin: hasPin, approvalStep, approvalType } = useDetailsDAR();

  const handleUpdatePin = useCallback(
    async (isPin: boolean) => {
      try {
        if (!itDeleteAccountRequest) return;
        const pins: any[] = itDeleteAccountRequest.fields.ePins ? JSON.parse(itDeleteAccountRequest.fields.ePins) : [];
        const index = pins.findIndex((pin: string) => pin === email?.toLowerCase());
        if (!isPin && index < 0) return;
        if (isPin && index > -1) return;
        if (!isPin && index > -1) pins.splice(index, 1);
        if (isPin && index < 0) pins.push(email?.toLowerCase());

        const fields = {
          ePins: JSON.stringify(pins),
        };
        updateDeleteAccountRequest(
          { id: itDeleteAccountRequest.id, body: fields },
          { successText: hasPin ? "Bỏ ghim thành công" : "Ghim thành công" },
        );
      } catch (error) {
        console.log(error);
      }
    },
    [email, itDeleteAccountRequest, hasPin, updateDeleteAccountRequest],
  );

  const ctx = useMemo<ProcessContextType>(
    () => ({
      Request: itDeleteAccountRequest,
      approvalStep,
      approvalType,
      comment,
      setComment,
      updatePin: handleUpdatePin,
      isPin: () => hasPin,
    }),
    [approvalStep, approvalType, comment, handleUpdatePin, hasPin, itDeleteAccountRequest],
  );

  const handleGoBack = () => {
    history.push(Routes.procedureDeleteUserAccount.path);
  };

  if (isLoading) return <Spin />;

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={handleGoBack}>
            <Icon.ArrowLeft />
          </div>
          {"Xem Xét Yêu Cầu Duyệt"}
        </div>
      </div>

      <ProcessContextProvider context={ctx}>
        <ItDeleteAccountProgress />
        <ItDeleteAccountInformation />
      </ProcessContextProvider>
    </div>
  );
});
